(function () {
  var VARIANT = '44601173475415';
  var QTY = [1, 2, 3];

  /* bundles: choose a pack, both buy buttons follow */
  var bundles = [].slice.call(document.querySelectorAll('.ed-hero-bundle'));
  function pick(i) {
    bundles.forEach(function (b, k) {
      b.classList.toggle('ed-hero-bundle-selected', k === i);
      var r = b.querySelector('.ed-hero-bundle-radio');
      if (r) r.classList.toggle('ed-hero-bundle-radio-selected', k === i);
    });
    [].slice.call(document.querySelectorAll('a[data-js-buy]')).forEach(function (a) {
      a.setAttribute('href', '/cart/' + VARIANT + ':' + QTY[i]);
      a.removeAttribute('target');
    });
  }
  bundles.forEach(function (b, i) {
    b.addEventListener('click', function (e) { e.preventDefault(); pick(i); });
  });
  var start = bundles.map(function (b) { return b.classList.contains('ed-hero-bundle-selected'); }).indexOf(true);
  pick(start < 0 ? 0 : start);

  /* gallery: thumbnails and arrows switch the main photo */
  (function () {
    var main = document.querySelector('.ed-hero-image');
    var thumbs = [].slice.call(document.querySelectorAll('.ed-hero-thumb'));
    if (!main || !thumbs.length) return;
    var cur = 0;
    function show(i) {
      cur = (i + thumbs.length) % thumbs.length;
      main.style.setProperty('background-image', getComputedStyle(thumbs[cur]).backgroundImage, 'important');
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var ar = document.querySelectorAll('.ed-hero-thumb-arrow');
    if (ar[0]) ar[0].addEventListener('click', function () { show(cur - 1); });
    if (ar[1]) ar[1].addEventListener('click', function () { show(cur + 1); });
    show(0);
  })();

  /* FAQ rows open and close */
  [].slice.call(document.querySelectorAll('.ed-hero-faq')).forEach(function (row, i) {
    var head = row.querySelector('.ed-hero-faq-head');
    var body = row.querySelector('.ed-hero-faq-body');
    if (!head || !body) return;
    /* the first row ships open with an "up" chevron; use the same "down" chevron as the others and rotate it */
    var poly = row.querySelector('.ed-hero-faq-chev polyline');
    if (poly) poly.setAttribute('points', '6 9 12 15 18 9');
    var isAnswer = body.classList.contains('wld-answer');
    if (isAnswer) body.style.setProperty('display', 'none', 'important'); else row.classList.add('is-open');
    head.addEventListener('click', function () {
      var open = row.classList.toggle('is-open');
      if (open) body.style.removeProperty('display'); else body.style.setProperty('display', 'none', 'important');
    });
  });

  /* footer: use the store's homepage footer (isolated frame, no scripts / tracking) */
  (function () {
    var anchor = document.querySelector('.ed-root');
    if (!anchor) return;
    fetch('/', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var all = [].slice.call(doc.querySelectorAll('.shopify-section-group-footer-group'));
      if (!all.length) return;
      var grp = doc.createElement('div');
      grp.className = 'tb-footer-wrap';
      [].slice.call(doc.querySelectorAll('script,noscript,iframe')).forEach(function (e) { e.parentNode.removeChild(e); });
      var base = doc.createElement('base');
      base.setAttribute('href', location.origin + '/');
      base.setAttribute('target', '_top');
      doc.head.insertBefore(base, doc.head.firstChild);
      var stl = doc.createElement('style');
      stl.textContent = 'html,body{margin:0 !important;padding:0 !important;overflow:hidden !important}';
      doc.head.appendChild(stl);
      doc.body.innerHTML = '';
      all.forEach(function (e) { grp.appendChild(e); });
      doc.body.appendChild(grp);
      var frame = document.createElement('iframe');
      frame.setAttribute('title', 'Footer');
      frame.setAttribute('scrolling', 'no');
      frame.style.cssText = 'display:block;width:100%;border:0;height:300px';
      frame.srcdoc = '<!doctype html>' + doc.documentElement.outerHTML;
      function fit() {
        try {
          var g = frame.contentDocument.querySelector('.tb-footer-wrap');
          if (g) frame.style.height = Math.ceil(g.getBoundingClientRect().height) + 'px';
        } catch (e) {}
      }
      frame.addEventListener('load', function () {
        fit();
        try { new ResizeObserver(fit).observe(frame.contentDocument.querySelector('.tb-footer-wrap')); } catch (e) {}
        setTimeout(fit, 400); setTimeout(fit, 1500);
      });
      window.addEventListener('resize', fit);
      anchor.parentNode.insertBefore(frame, anchor.nextSibling);
    }).catch(function () {});
  })();
})();
